import React, { useState } from 'react';

export const ManualAdCarousel = ({ items = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  if (!items || items.length === 0) return null;

  const maxSlides = Math.min(items.length, 5);
  const slides = items.slice(0, maxSlides);
  const maxDesktopSlide = Math.max(0, slides.length - 2);

  const goToNext = () => setCurrentSlide((prev) => (prev + 1 > maxDesktopSlide ? 0 : prev + 1));
  const goToPrev = () => setCurrentSlide((prev) => (prev - 1 < 0 ? maxDesktopSlide : prev - 1));

  return (
    <div data-testid="ad-carousel" className="relative">
      {/* Desktop Layout - sliding carousel */}
      <div className="hidden md:block">
        <div className="relative overflow-hidden rounded-xl">
          <div className="flex transition-transform duration-500 ease-out gap-5" style={{ transform: `translateX(-${currentSlide * 51.5}%)` }}>
            {slides.map((item, index) => (
              <div key={index} className="w-[48%] flex-shrink-0">
                <div className="relative aspect-[3/1] overflow-hidden rounded-xl group">
                  {item.clickUrl ? (
                    <a href={item.clickUrl} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
                      <img src={item.imageUrl} alt={item.alt || `Ad ${index + 1}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading={index < 2 ? "eager" : "lazy"} width="1200" height="400" />
                    </a>
                  ) : (
                    <img src={item.imageUrl} alt={item.alt || `Ad ${index + 1}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading={index < 2 ? "eager" : "lazy"} width="1200" height="400" />
                  )}
                </div>
              </div>
            ))}
          </div>
          {slides.length > 2 && (
            <>
              <button onClick={goToPrev} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/95 shadow-md hover:shadow-lg transition-all z-10" aria-label="Previous">
                <svg className="w-5 h-5 text-[#00224F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
              </button>
              <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/95 shadow-md hover:shadow-lg transition-all z-10" aria-label="Next">
                <svg className="w-5 h-5 text-[#00224F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
              </button>
            </>
          )}
        </div>
        {slides.length > 1 && (
          <div className="flex items-center justify-center gap-2 mt-5">
            {slides.map((_, index) => (
              <button key={index} onClick={() => setCurrentSlide(Math.min(index, maxDesktopSlide))} className={`h-2 rounded-full transition-all duration-200 ${currentSlide === index ? 'bg-[#D4A853] w-6' : 'bg-[#E8E4DF] hover:bg-[#D4A853]/50 w-2'}`} aria-label={`Slide ${index + 1}`} />
            ))}
          </div>
        )}
      </div>

      {/* Mobile Layout - 2 rows grid */}
      <div className="md:hidden">
        <div className="grid grid-cols-1 gap-3">
          {slides.slice(0, 2).map((item, index) => (
            <div key={index} className="relative aspect-[3/1] overflow-hidden rounded-xl">
              {item.clickUrl ? (
                <a href={item.clickUrl} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
                  <img src={item.imageUrl} alt={item.alt || `Ad ${index + 1}`} className="w-full h-full object-cover" loading="eager" width="600" height="200" />
                </a>
              ) : (
                <img src={item.imageUrl} alt={item.alt || `Ad ${index + 1}`} className="w-full h-full object-cover" loading="eager" width="600" height="200" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
